// ==============================|| COMPONENTS - COMMON - HPRCHECKBOX ||============================== //

import {
  Checkbox,
  FormControlLabel,
  Tooltip,
} from "../../../common/utils/mui-imports";
import { ChangeEvent, useState } from "react";
import { HPRCheckBoxProps } from "./HPRCheckBox.types";
import "../../../scss/styles.scss";

const HPRCheckBox = (props: HPRCheckBoxProps) => {
  const [value, setValue] = useState(props.checked ? props.checked : false);

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.checked);
    if (props.onCheckBoxChange)
      props.onCheckBoxChange(event.target.name, event.target.checked);
  };

  const handleClick = (event: any) => {
    if (props.onCheckBoxClick) {
      props.onCheckBoxClick(event);
    }
  };

  const formControlLabel = (
    <FormControlLabel
      control={
        <Checkbox
          id={props.Id}
          name={props.Name}
          checked={props.checked}
          indeterminate={props.indeterminateChecked}
          //indeterminateIcon={<Filter variant="Outline" />}
          required={props.Required}
          disabled={props.Disabled ? props.Disabled : false}
          onChange={onChange}
          className={`${
            props.Disabled ? `disabled ${props.ClassName}` : props.ClassName
          }}`} //check prop disable
          sx={{
            color: "#219ebc",
            borderWidth: 1,
            cursor: "pointer",
            "&.Mui-checked": {
              color: "#219ebc",
            },
            "&.Mui-disabled": {
              cursor: "default",
            },
          }}
          onClick={handleClick}
        ></Checkbox>
      }
      label={props.Label}
      style={{
        maxWidth: "max-content",
        cursor: props.Disabled ? "default" : "pointer",
      }}
      className={`hpr-checkbox-multiline ${props.LabelClassName ?? ""}`}
    />
  );

  // Conditionally wrap with Tooltip if showLabelTooltip is true
  return props.showLabelTooltip ? (
    <Tooltip
      title={props.Label}
      placement="bottom-start"
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [35, -10],
              },
            },
          ],
        },
      }}
    >
      {formControlLabel}
    </Tooltip>
  ) : (
    formControlLabel
  );
};

export default HPRCheckBox;
